// extracted by mini-css-extract-plugin
export default {"p_content":"_8e0721ba8b"};